// extracted by mini-css-extract-plugin
module.exports = {"smallplan":"smallfloorplan_smallplan__3pDxC","heading":"smallfloorplan_heading__1gOnP"};